export default "__VITE_ASSET__eCqI$lvWQ4xjFpnVHyoJIA__";